import React, { useRef } from 'react'

import { Messages, MessagesMessage } from 'primereact/messages'

import { InvoiceMessageContext } from './invoiceMessageContext'

interface InvoiceMessageContextProviderProps {
  children?: React.ReactNode
}

const InvoiceMessageContextProvider: React.FC<
  InvoiceMessageContextProviderProps
> = ({ children }) => {
  const messagesRef = useRef<Messages>(null)

  const showMessage = (message: MessagesMessage | MessagesMessage[]) => {
    if (!messagesRef.current) return
    messagesRef.current.show(message)
  }

  const replaceMessage = (message: MessagesMessage | MessagesMessage[]) => {
    if (!messagesRef.current) return
    messagesRef.current.replace(message)
  }

  const removeMessage = (message: MessagesMessage | MessagesMessage[]) => {
    if (!messagesRef.current) return
    messagesRef.current.remove(message)
  }

  const clearMessages = () => {
    if (!messagesRef.current) return
    messagesRef.current.clear()
  }

  return (
    <InvoiceMessageContext.Provider
      value={{ showMessage, replaceMessage, removeMessage, clearMessages }}
    >
      <Messages ref={messagesRef} />
      {children}
    </InvoiceMessageContext.Provider>
  )
}

export default InvoiceMessageContextProvider
